
import EmbeddedRecorder from 'zoomforth_embedded_recorder/embedded_recorder.js';

import CameraHelpModalView from './camera_help_modal.js';

(function() {


  function makeNewDefaultResponse(attrs, options) {
    if (!zfrespond.app.contactCampaign) {
      throw "No Default ContactCampaign defined";
    }
    if (!zfrespond.app.loggedInUserMode) {
      // Logged in user's do not need to specify this information...
      attrs = _.extend({
        collector_contact_campaign_id: zfrespond.app.contactCampaign.id,
        collector_contact_id: zfrespond.app.contactCampaign.get('collector_contact_id')

      }, attrs);
    }
    return new zfrespond.models.Response(attrs, options);
  }


  zfrespond.views.RespondView = Backbone.View.extend({

    className: "respond-view",

    template: ZFRESPOND_JST.respond,

    mobile: false,

    events: {
      'click .action-add-text': "handleAddText",
      'click .action-record': 'handleRecord',
      'click .action-cancel-recording': 'handleCancelRecording',
      'click .action-show-camera-help': 'handleShowCameraHelp',
      'click .action-toggle-expand': 'handleToggleExpand',
      'click .action-done': 'handleDone',
      'click .action-skip': 'handleSkip'

    },

    initialize: function(options) {

      this.mediaCollector = options.mediaCollector;
      this.responses = options.responses;

      this.recorderView = null;
      
      this.listenTo(this.responses, 'add', this.onAddResponse);
      this.listenTo(this.responses, 'add remove reset', this.renderCount);

      this.listenTo(this.responses, 'edit:start', this.onEdit);

      this.currentEditView = null;

      this._allUploaderViews = [];

      var allowed = this.model.get('allowed_media_types');
      if (this.mobile) {
        var withoutVideo = _.without(allowed, 'video');
        var withVideo = _.difference(allowed, withoutVideo);
        this.anyUploader = this.makeUploaderData(withoutVideo); //, {hideDisplayNames:['pdf']});
        this.videoUploader = this.makeUploaderData(withVideo); 
      } else {
        this.anyUploader = this.makeUploaderData(allowed);
        this.videoUploader = this.makeUploaderData([]);
      }

    },

    render: function() {

      if (this.anyUploader.enabled && !this.mobile) {
        // Add drag events for visualization of dropzone
        this.delegateEvents(_.extend({
          'dragover': 'handleDragenter',
          'dragenter': 'handleDragenter',
          'dragexit': 'handleDragexit',
          'dragleave': 'handleDragexit',
          'dragend': 'handleDragexit',
          'drop': 'handleDragexit'

        }, this.events));               
      }

      var videoAllowed = _.contains(this.model.get('allowed_media_types'), 'video');
      
      var buttonBooleans = {
        hasAnyUploader: !!this.anyUploader.enabled,
        hasVideoUploader: !!this.videoUploader.enabled,
        hasRecorder: videoAllowed && !this.mobile,
        hasText: _.contains(this.model.get('allowed_media_types'), 'text')
      };
      
      var templateVariables = buttonBooleans;
      
      templateVariables.numberOfButtons = _.filter(buttonBooleans, function(hasButton){
        return hasButton;
      }).length;
      
      templateVariables.text_prompt = this.model.get('text_prompt');
      templateVariables.details = this.model.get('details') || '';

      this.$el.html(this.template(templateVariables));

      this.$('.field-body').hide();


      var uploadPrefix = this.mobile ? 'Add' : 'Upload';

      // Only render UploaderView if we want to allow Images, Videos or PDFs
      if (this.anyUploader.enabled) {
        this.makeUploaderView(
          this.$('.add-container-any-upload').find('.add-upload-container'), 
          {
            accept: this.anyUploader.accepts,
            dropZone: true
          }
        );

        this.$('.add-container-any-upload').find('.add-upload-container').append(
          this.getUploaderButtonText(
            uploadPrefix,
            this.anyUploader.mediaDisplayNames
          )
        );
        
      }
      
      if (this.videoUploader.enabled) {
        
        this.makeUploaderView(
          this.$('.add-container-video-upload').find('.add-upload-container'), 
          {
            accept: this.videoUploader.accepts,
            dropZone: false
          }
        );
        
        this.$('.add-container-video-upload').find('.add-upload-container').append(
          this.getUploaderButtonText(
            uploadPrefix,
            this.videoUploader.mediaDisplayNames
          )
        );
        
      }

      this.$('.workspace').hide();

      this.$('.cancel-button-container').hide();
      this.$('.camera-help-button-container').hide();

      this.renderCount();

      this.responses.each(_.bind(this.onAddResponse, this));

      return this;
    },

    renderCount: function() {
      this.$('.field-header .count').text(this.responses.length);
    },

    makeUploaderData: function(allowedMediaTypes, options) {
      options = options || {};
      var hideDisplayNames = options.hideDisplayNames || [];
      var data = {
        mediaDisplayNames: [],
        accepts: []
      };
      if (_.contains(allowedMediaTypes, 'photo')) {
        if (!_.contains(hideDisplayNames,'photo')) {
          data.mediaDisplayNames.push('Image');
        }
        data.accepts.push('image/*');
      }
      if (_.contains(allowedMediaTypes, 'video')) {
        if (!_.contains(hideDisplayNames,'video')) {
          data.mediaDisplayNames.push('Video');
        }
        data.accepts.push('video/*');
      }
      if (_.contains(allowedMediaTypes, 'pdf')) {
        if (!_.contains(hideDisplayNames,'pdf')) {
          data.mediaDisplayNames.push('PDF');
        }
        data.accepts.push('.pdf');
        data.accepts.push('application/pdf');
      }
      data.enabled = !!data.accepts.length;
      return data;
    },

    makeUploaderView: function($container, options) {

      var uploaderOptions = {
        enableThumbnails: true,
        initialPrecursorData: {
          account_id: this.mediaCollector.get('account_id'),
          upload_context: 'collector_response'
        },
        ...options
      };

      // grab a handle to the uploader view 
      var newUploaderView = zfUploader.UploaderView.create(
        $container, 
        uploaderOptions
      );

      this.listenTo(newUploaderView, 'started', function(assetPrecursor) { 
        this.listenToOnce(assetPrecursor, 'upload-begun', function() {
          this.onStartedUpload(assetPrecursor);
        });
        this.trigger('upload-started', assetPrecursor);
      });
      
      return newUploaderView
    },
    
    getUploaderButtonText: function(prefix, mediaDisplayNames){
      var uploadButtonString = prefix + ' ' + mediaDisplayNames.slice(0, -1).join(', ');
      if (mediaDisplayNames.length === 1) {
        uploadButtonString += mediaDisplayNames[0];

      } else if (mediaDisplayNames.length > 1) {
        if (mediaDisplayNames.length > 2) {
          uploadButtonString += ',';
        }
        uploadButtonString += ' or ' + mediaDisplayNames.slice(-1)[0];
      }
      return uploadButtonString;
    },

    makeResponseView: function(response) {
      return new zfrespond.views.MediaResponseThumbnailView({ 
        model: response, editing:true, clickTriggersEdit: true 
      });
    },

    makeResponseViewOrDie: function(response) {
      if (_.contains(['photo','pdf','video','text'], response.get('media_type'))) {
        return this.makeResponseView(response);

      } else {
        throw "Unexpected Media Type: " + response.get('media_type');
      }
    },

    addResponseView: function(responseView) {
      // We save the view on the actual $element so we can find the view
      // by the element later
      responseView.$el.data('view', responseView); 
      this.$('.responses-container').append(responseView.render().$el);
    },

    isAlreadyPresentResponse: function(response) {
      var found = false;
      this.$('.responses-container .response-view').each(function() {
        found = $(this).data('view').model.cid === response.cid;
        return !found; // Stop iteration when found === `true`
      });
      return found;
    },

    expand: function() {
      this.$('.field-body').slideDown();
      this.$el.addClass('expanded');
      this.trigger('expanded', this, { neighborsShould:'unexpand' });
    },

    isExpanded: function() {
      return this.$el.hasClass('expanded');
    },

    unexpand: function() {
      var me = this;
      this.$('.field-body').slideUp(400, function() {
        me.$el.removeClass('expanded');
      });
      this.trigger('unexpanded', this);
    },

    unexpandAndExpandNext: function() {
      var me = this;
      this.$('.field-body').slideUp(400, function() {
        me.$el.removeClass('expanded');
      });
      this.trigger('unexpanded', this, { neighborsShould:'expandnext' });
    },

    _showEditResponseView: function(response, ResponseView) {
      this.$('.response-fyi-container').hide();
      this.$('.cancel-button-container').hide();

      if (this.currentEditView) {
        this.currentEditView.remove();
      }
      this.currentEditView = new ResponseView({ 
        model: response
      });
      // response.trigger('edit:start', this.currentEditView);
      this.$('.workspace').show().append(this.currentEditView.render().$el); // Append the new view $el

      this.currentEditView.focus();

      this.listenToOnce(this.currentEditView, 'submit', function() {
        response.trigger('edit:end', this.currentEditView);
        this.$('.workspace').hide();
        this.currentEditView.remove();
      });

      return this.currentEditView;      
    },

    showEditTextResponseView: function(response) {
      return this._showEditResponseView(response, zfrespond.views.EditTextResponseView);
    },

    showEditMediaResponseView: function(response) {
      return this._showEditResponseView(response, zfrespond.views.EditMediaResponseView);
    },

    // Internal event handlers

    onEdit: function(response) {
      if (response.get('media_type') === 'text') {
        this.showEditTextResponseView(response);
      } else {
        this.showEditMediaResponseView(response);
      }
    },


    onAddResponse: function(response) {
      if (this.isAlreadyPresentResponse(response)) {
        // This ensures we don't add another UploadableMediaView 
        // when the response model is added to responses
        return;
      }

      this.$el.addClass('responded');
      this.$('.response-explanation').show();

      this.addResponseView(this.makeResponseViewOrDie(response));
    },

    onStartedUpload: function(assetPrecursor) {
      if (!this.isExpanded()) {
        this.expand();
      }

      // precursors always have a presumed type
      var mediaType = assetPrecursor.get('presumedType');
      var response = makeNewDefaultResponse({ 
        collector_field_id: this.model.id,
        media_collector_id: this.model.get('media_collector_id'),
        media_type: mediaType
      }, {
        assetPrecursor: assetPrecursor
      });
      this.showEditMediaResponseView(response);
      this.responses.add(response);

      this.listenTo(assetPrecursor, 'processing-complete', function() {
        response.save({
           asset_ident: assetPrecursor.getAssetIdentifierString()
        });
      });
    },


    // User action event handler

    handleToggleExpand: function(e) {

      if (e.target === this.$('.action-skip').get(0) ||
          e.target === this.$('.action-done').get(0)) {
        // Don't preform this `toggleExpand` action for clicks on the
        // done and skip buttons
        return;
      }

      if (this.$el.hasClass('expanded')) {
        this.unexpand();
      } else {
        this.expand();
      }
    },

    handleDone: function() {
      this.unexpandAndExpandNext();
    },

    handleSkip: function() {
      this.unexpandAndExpandNext();
    },
    
    handleAddText: function() {
      var me = this;
      var response = makeNewDefaultResponse({
        collector_field_id: this.model.id,
        media_collector_id: this.model.get('media_collector_id'),
        media_type: 'text'
      });

      var view = this.showEditTextResponseView(response);

      this.listenToOnce(view, 'submit', function() {
        me.responses.add(response);
      });

    },
    
    handleRecord: function() {

      if (this.currentEditView) {
        this.currentEditView.remove();
      }
        
      var recorder = EmbeddedRecorder.create({
        fullWindow: true,
        recorderOptions: {}
      });
      recorder.once('ready-to-save-video', (videoBlob)=> {
        // there is no problem making new recorder every time.
        // ideally we completely refactor uploader views out of this.
        var tmpUploaderView = this.makeUploaderView(
          this.$('.add-container-record'), 
          {
            accept: ['video/*'],
            dropZone: false
          }
        )
        tmpUploaderView.$el.hide();
        tmpUploaderView.addFromBlob(videoBlob);
        recorder.remove();
        recorder = null;
      });

    },
    
    handleCancelRecording: function() {
      if (this.recorderView) {
        this.recorderView.remove();
        this.$('.cancel-button-container').hide();
        this.$('.camera-help-button-container').hide();
      }
    },

    handleShowCameraHelp: function() {
      throw new Error('There should no longer be a desktop page for help that we serve - should be mobile only');
    },

    handleDragenter: function() {
      this.$el.addClass('drag-upload-hover');
    },
    handleDragexit: function() {
      this.$el.removeClass('drag-upload-hover');
    }

  });



  zfrespond.views.RespondFullpageView = zfrespond.views.RespondView.extend({
    
    events: _.extend({},
      zfrespond.views.RespondView.prototype.events, {
      'click .action-go-back': 'handleGoBack',
      'click .action-done': 'handleDone',
      'click .action-interstitial-interceptor': 'handleInterceptAddVideoClick'
    }),

    mobile: true,

    className: "respond-view respond-fullpage-view",

    template: ZFRESPOND_JST.respond_fullpage,

    render: function() {
      zfrespond.views.RespondFullpageView.__super__.render.call(this);
      this.$('.header').hide();
      // this is the function that enables the mobile interstitial
      this._addInterstitialMask();

      // If video enabled for this response, show the camera help button
      if (_.contains(this.model.get('allowed_media_types'), 'video')) {
        this.$('.camera-help-button-container').show();
      }
      return this;
    },
    
    _addInterstitialMask: function() {
      // makes a transparent cover over the add video button that intercepts the click, 
      // shows the interstitial, and then a click on the interstitial triggers a click on
      // the underlying uploader element
      var $clickInterceptor = $('<div class="action-interstitial-interceptor"></div>');
      this.$('.add-container-video-upload').append($clickInterceptor);
    },

    makeResponseView: function(response) {
      return new zfrespond.views.MediaResponseThumbnailView({ 
        model: response, editing:true, clickTriggersEdit: true
      });
    },
    
    handleInterceptAddVideoClick: function() {
      // show an interstitial, then use the dismiss interstitial click 
      // (which causes deferred to resolve)
      // as user event that allows us to trigger a click on the video upload form,
      var me = this;
      var interstitial = new zfrespond.views.MobileVideoInterstitial({});
      interstitial.render();
      this.$el.append(interstitial.$el);
      interstitial.getPromise().done(function() {
        interstitial.remove();
        me.$('.add-container-video-upload input.action-upload-file').trigger('click');
      });
    },

    expand: function() {
      this.trigger('expanded', this, {neighborsShould:'contract', isolate:true });
    },

    unexpand: function() {
      this.trigger('unexpanded', this, {neighborsShould:'uncontract', unisolate:true });
    },


    contract: function() {
      this.$el.css({
        'visibility': 'hidden'
      });
      this.$el.addClass('contracted');
      return;
    },

    isContracted: function() {
      return this.$el.hasClass('contracted');
    },

    uncontract: function() {
      this.$el.css({
        'visibility': ''
      });
      this.$el.removeClass('contracted');
      return;
    },


    showEditTextResponseView: function(response) {
      var detailView = new zfrespond.views.EditTextResponseFullpageView({ model:response });
      this.trigger('push-view', detailView.render());
      detailView.focus();
      return detailView;
    },

    showEditMediaResponseView: function(response) {
      var detailView = new zfrespond.views.EditMediaResponseFullpageView({ model:response });
      this.trigger('push-view', detailView);
      detailView.render();
      detailView.focus();
      return detailView;
    },

    handleShowCameraHelp: function() {

      CameraHelpModalView.show({
        mode: 'mobile'

      });
    },

    handleToggleExpand: function() {
      if (this.$el.hasClass('expanded')) {
        // no-op
        // We don't let you un-expand by clicking on the header
      } else {
        this.expand();
      }
    },

    handleGoBack: function() {
      this.unexpand();
    },

    handleDone: function() {
      this.unexpand();
    }

  });

  

}());